export const auth = {
    strava: {
        keyPairId: 'APKAIDPUN4QMG7VUQPSA',
        policy: 'eyJTdGF0ZW1lbnQiOiBbeyJSZXNvdXJjZSI6Imh0dHBzOi8vaGVhdG1hcC1leHRlcm5hbC0qLnN0cmF2YS5jb20vKiIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTYzMjU5NzQ1M30sIkRhdGVHcmVhdGVyVGhhbiI6eyJBV1M6RXBvY2hUaW1lIjoxNjMxMzczNDUzfX19XX0_',
        signature: 'ZwJn9hlSWJQ5NuzSyhqqV0voAHl4ODXl9MlC8U53S~08q0Pyy2LPmAvos1Zzh4Has3VXI9aAF4EWtbWZKE7rBKWTLPDeIi-UOOZBi3Meuh3EIznkK7NMcAeU8zHh0RK61B95NfIfNfTmoQDjtwjNqKsuP~bW9zRqO3O9G-WKyCW68yfpY2c5UGFY~GCrQGfohJyo46F7ZWqwIl3MfFXz5QE8Y1TiuD5RNBtjTXHBjFYWEQD35Z6CX0v46SfvRRnlgiNIbMfTkhwDybTLACIH4VODwEuRcFnOLccEw4YIHsDtvcW-gBvUmmMrgSPBB5ncxu42MlaxoxEEfDm08HPrlQ__',
    },
};
